// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Mm-Cv","badges":"styles_badges__1UhOr"};